import { Box } from '@mui/material';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import CopyToClipboard from '../copyToClipBoard/CopyToClipboard';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  const supportedVideoExtensions = ['mp4', 'mov', 'avi', 'webm'];

  const isDirectVideo = (url: string) => {
    if (!url) return false;
    const lowerCaseUrl = url.toLowerCase();
    return supportedVideoExtensions.some((ext) => lowerCaseUrl.endsWith(`.${ext}`));
  };

  const components = {
    code({ node, inline, className, children, ...props }: any) {
      const match = /language-(\w+)/.exec(className || '');
      const codeContent = String(children).replace(/\n$/, '');
      return !inline && match ? (
        <div style={{ position: 'relative' }}>
          <SyntaxHighlighter style={oneLight} language={match[1]} PreTag="div" {...props}>
            {codeContent}
          </SyntaxHighlighter>
          <Box sx={{ position: 'absolute', top: '10px', zIndex: '1', right: '10px' }}>
            <CopyToClipboard textToCopy={codeContent} />
          </Box>
        </div>
      ) : (
        <code className={className} {...props}>
          {children}
        </code>
      );
    },

    a({ href, children, ...props }: any) {
      if (isDirectVideo(href)) {
        return (
          <Box>
            <video width="640" height="360" controls>
              <source src={href} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Box>
        );
      }
      return (
        <a href={href} target="_blank" rel="noreferrer" {...props}>
          {children}
        </a>
      );
    },
  };

  return (
    <Box>
      <ReactMarkdown components={components} remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {content || 'No content available.'}
      </ReactMarkdown>
    </Box>
  );
};

export default MarkdownRenderer;
